module.exports = __webpack_public_path__ + "img/scatter_plot.37f44bdb.svg";